import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=345a1325&scoped=true"
import script from "./personalCard.vue?vue&type=script&lang=js"
export * from "./personalCard.vue?vue&type=script&lang=js"
import style0 from "./personalCard.vue?vue&type=style&index=0&id=345a1325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a1325",
  null
  
)

export default component.exports